<div class="d-flex flex-row social-media">
    <a target="_new" href="https://rekbot.pl/">
        <img src="./assets/img/rekbot-icon.png" alt="">
    </a>
    <a target="_new" href="https://www.facebook.com/Rekbotpl">
        <img src="./assets/img/fb.png" alt="">
    </a>
    <a target="_new" href="https://www.linkedin.com/company/rekbot/">
        <img src="./assets/img/linkedin.png" alt="">
    </a>
    <a target="_new" href="https://www.instagram.com/rekbot.pl/">
        <img src="./assets/img/instagram.png" alt="">
    </a>
</div>
